import { render, staticRenderFns } from "./IconAiGenerated.vue?vue&type=template&id=1ce39466"
import script from "./IconAiGenerated.vue?vue&type=script&lang=js"
export * from "./IconAiGenerated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports